import React from 'react'
import { useTranslation } from 'react-i18next'
import { PatientTypeOptions } from 'src/config/patientTypeOptions'
import useStyles from './styles'
import { Button } from '@components/Button/Button'
import { TEST_IDS } from 'src/constants/testIds'

interface Props {
  openAna: () => void
  healthAssistantLink: string | undefined
  linkToAna: string | undefined
  hasHealthAssistant: boolean
  hasValidAnamnesis: boolean
  patientType: PatientTypeOptions | undefined
}

export const ActionButtons = ({
  linkToAna,
  healthAssistantLink,
  hasHealthAssistant,
  hasValidAnamnesis,
  patientType,
  openAna,
}: Props) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const goToHealthAssistant = () => {
    if (healthAssistantLink) window.open(healthAssistantLink, '_blank')
  }

  const ctaContent = (() => {
    if (patientType === PatientTypeOptions.NEW) {
      return linkToAna ? (
        <>
          <div className={classes.ctaText}>{t('booking_success_new_patient_ana_text')}</div>
          <div className={classes.ctaButtonContainer}>
            <Button
              text={t('booking_success_ana_cta')}
              onClick={openAna}
              size="xl"
              phoneSize="lg"
              data-test={TEST_IDS.anamnesisButton}
              className={classes.ctaButton}
            />
          </div>
        </>
      ) : null
    }

    // With HA, no ANA
    if (hasHealthAssistant && !hasValidAnamnesis) {
      return (
        <>
          <div className={classes.ctaText}>{t('booking_success_with_ha_no_ana_text')}</div>
          <div className={classes.ctaButtonContainer}>
            <Button
              text={t('booking_success_with_ha_no_ana_cta')}
              onClick={goToHealthAssistant}
              size="xl"
              phoneSize="lg"
              data-test={TEST_IDS.healthAssistantButton}
              className={classes.ctaButton}
            />
          </div>
        </>
      )
    }

    // With HA, with ANA
    if (hasHealthAssistant && hasValidAnamnesis) {
      return (
        <>
          <div className={classes.ctaText}>{t('booking_success_with_ha_with_ana_text')}</div>
          <div className={classes.ctaButtonContainer}>
            <Button
              text={t('booking_success_with_ha_with_ana_cta')}
              onClick={goToHealthAssistant}
              size="xl"
              phoneSize="lg"
              data-test={TEST_IDS.healthAssistantButton}
              className={classes.ctaButton}
            />
          </div>
        </>
      )
    }

    // No HA, no ANA
    if (!hasHealthAssistant && !hasValidAnamnesis) {
      return null
    }

    // No HA, with ANA
    if (!hasHealthAssistant && hasValidAnamnesis) {
      return null
    }
  })()

  return <div className={classes.container}>{ctaContent}</div>
}
